/**
 * Ported from the Next.js ScrollToServices — no Next-specific APIs, unchanged.
 */
export function ScrollToServices() {
  // Sticky header is 5rem (h-20). Subtract it plus a 1rem gap so the
  // section title doesn't sit flush under the header. scroll-mt on the
  // target only applies to scrollIntoView/native anchors, not to
  // window.scrollTo, so the offset has to be applied manually here.
  const HEADER_OFFSET_PX = 75;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const servicesSection = document.getElementById("services");
    if (servicesSection) {
      const elementPosition = servicesSection.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - HEADER_OFFSET_PX;
      // Instant jump — DESIGN.md Motion: no scroll effects.
      window.scrollTo({ top: offsetPosition });
    }
  };

  return (
    <a
      href="#services"
      onClick={handleClick}
      className="text-gray-900 font-bold text-lg underline underline-offset-4 cursor-pointer"
    >
      View Services ↓
    </a>
  );
}
